<template>
    <div>
        <div v-for="cg in contacts">
            <template v-if="cg.contactType==='_whatsapp'">
                <div v-for="item in cg.items" class="col-xs-12" style="height:40px;line-height:40px;padding:2px;margin:4px;border-bottom:1px solid gray;">
                    <div class="col-xs-8" style="text-align:center;">
                        {{item.contact}}
                    </div>
                    <div class="col-xs-4" style="text-align:left;">
                        <a :href="'https://wa.me/'+item.contact+'?text='+currentUrl+' %0a '" target="_blank">
                            <img class="agx-whatsapp-icon" src="/images/sns/whatsapp.png" />
                        </a>
                    </div>
                </div>
            </template>
            <template v-if="cg.contactType==='_email'">
                <div v-for="item in cg.items" class="col-xs-12" style="height:40px;line-height:40px;padding:2px;margin:4px;border-bottom:1px solid gray;">
                    <div class="col-xs-8" style="text-align:center;">
                        {{item.contact}}
                    </div>
                    <div class="col-xs-4" style="text-align:left;">
                        <a class="glyphicon glyphicon-send agx-email-icon" :href="'mailto:'+item.contact"></a>
                    </div>
                </div>
            </template>
            <template v-if="cg.contactType==='_phone'">
                <div v-for="item in cg.items" class="col-xs-12" style="height:40px;line-height:40px;padding:2px;margin:4px;border-bottom:1px solid gray;">
                    <div class="col-xs-8" style="text-align:center;">
                        {{item.contact}}
                    </div>
                    <div class="col-xs-4" style="text-align:left;">
                        <a class="glyphicon glyphicon-send agx-phone-icon" :href="'tel:'+item.contact"></a>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>


<script>
    export default {
        components: {
            
        },
        props: ["contacts"],
        data: function () {
            return {
                //currentUrl: window.location.href
                pageUrl: window.location.href
            }
        },
        computed:{
            currentUrl:function(){
                //return window.location.href;
                return encodeURIComponent(this.pageUrl);
            }
        },
        watch: {
            '$route'() {
                this.pageUrl = window.location.href;
                console.log('route changed', this.pageUrl);
            }
        },
        mounted: function () {
            
        }
    }
</script>